export class DataField {
  constructor({
        id= null, 
        name= ``, 
        attribute= ``, 
        upperLimit= ``,
        lowerLimit= ``, 
        upperColor= `#ff1e02`,
        lowerColor= `#90cf5b`,
        description= ``
    } = {}) {
    this.id = id;
    this.name = name;
    this.attribute = attribute;
    this.upperLimit = upperLimit;
    this.lowerLimit = lowerLimit;
    this.upperColor = upperColor;
    this.lowerColor = lowerColor;
    this.description = description;
  }
}
export function newEntity() {
  return new DataField();
}
export function gridFields() {
  return Object.freeze([
      {
        key: 'name',
        label: 'lbl.dataField.name',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'attribute',
        label: 'lbl.dataField.attribute',
        sortable: true,
        form: {
          type: 'input'
        }
      },
     
      {
        key: 'upperLimit',
        label: 'lbl.dataField.upperLimit',
        form: {
          type: 'input'
        }
      },
      {
        key: 'lowerLimit',
        label: 'lbl.dataField.lowerLimit',
        sortable: true,
        form: {
          type: 'input'
        }
      }  ,
      {
        key: 'upperColor',
        label: 'lbl.dataField.upperColor',
        sortable: true,
        form: {
          type: 'color'
        }
      }     ,
      {
        key: 'lowerColor',
        label: 'lbl.dataField.lowerColor',
        sortable: true,
        form: {
          type: 'color'
        }
      },
      {
        key: 'description',
        label: 'lbl.dataField.description',
        sortable: true,
        form: {
          type: 'input'
        }
      }     
  ]);
}
export const fields = Object.freeze(Object.keys(new DataField()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.nameFilter',
  'filter.descriptionFilter',
];
export const filter = {
  'nameFilter': "",
  'descriptionFilter':"",
};